import { useStyles } from '@archipro-design/aria';
import * as S from './ContactPage.desktop.style';

export const Divider: React.FC = () => {
    const { css } = useStyles();
    return <hr className={css(S.LineDivider)} />;
};
